var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.QianMingBlon)?_c('Signature',{on:{"Suc":_vm.QianMingSuc,"back":_vm.Back}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }